import { B2CQueueConfigSaveResult, B2CReturnState, ReturnSlip } from 'returnCenter-api';
import { b2cQueueApi, returnApi } from './api';

/** B2B2C returns - announcing completed returns to the e-commerce system, and its answers. */
export const b2cService = {
    getConfig: async (): Promise<string | null> => {
        const response = await b2cQueueApi.b2CQueueGetConfig();
        return response.data.configJson ?? null;
    },

    /** Resolves with the validation result also when it has errors (400): nothing is saved then. */
    saveConfig: async (configJson: string): Promise<B2CQueueConfigSaveResult> => {
        const response = await b2cQueueApi.b2CQueueSaveConfigPUT(
            { b2CQueueConfigDto: { configJson } },
            { validateStatus: (status) => status === 200 || status === 400 },
        );
        return response.data;
    },

    /** What was sent for the return, and what the server allows to be done about it. */
    getState: async (returnId: number): Promise<B2CReturnState> => {
        const response = await returnApi.returnGetB2CState({ returnId });
        return response.data;
    },

    markHandled: async (returnId: number, comment?: string, language?: string): Promise<ReturnSlip> => {
        const response = await returnApi.returnMarkB2CHandledPOST({
            returnId,
            language,
            b2CHandledRequest: { comment: comment || null },
        });
        return response.data;
    },

    getAttentionCount: async (): Promise<number> => {
        const response = await returnApi.returnGetB2CAttentionCount();
        return response.data;
    },

    resend: async (returnId: number, language?: string): Promise<ReturnSlip> => {
        const response = await returnApi.returnResendB2CPOST({ returnId, language });
        return response.data;
    },
};
